<script>
  import getTranslation from '../../../utilities/getTranslation';
  export let isMostPopular,
    showCurrentPlanOnGroupLevel,
    showUpcomingPlanOnGroupLevel,
    currentSubscription,
    componentInformationKeys;

  const wrapperTitle = () => {
    if (isMostPopular) {
      return getTranslation(componentInformationKeys, 'subscription.mostpopular.v2');
    } else if (showCurrentPlanOnGroupLevel && currentSubscription.active) {
      return getTranslation(componentInformationKeys, 'subscription.currentsubscription.v2');
    } else if (showCurrentPlanOnGroupLevel && !currentSubscription.active) {
      return getTranslation(
        componentInformationKeys,
        'subscription.currentcancelledsubscription.v2'
      );
    } else if (showUpcomingPlanOnGroupLevel) {
      return getTranslation(componentInformationKeys, 'subscription.upcomingsubscription.v2');
    } else {
      return '';
    }
  };
</script>

<style lang="scss">
  @use '../index' as *;

  .most-popular {
    display: flex;
    justify-content: center;
    height: 3.2rem;
    max-width: 34.1rem;
    min-width: 25.6rem;
    background-color: $black;
    color: $white;
    padding-block-end: 0.5rem;
    padding: spacing(1) 0;
    border-radius: 1.3rem 1.3rem 0 0;
    box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.07);
    font-size: 1.3rem;
    font-weight: 600;
  }

  .has-current-plan {
    display: flex;
    height: 3.2rem;
    align-items: center;
    justify-content: center;
    border-radius: 1rem 1rem 0 0;
    background-color: $bright-green-30;
    color: $black;
    box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.07);
    font-size: 1.3rem;
    font-weight: 600;

    &-cancelled {
      background-color: $bright-red-20;
    }
  }
</style>

<div
  class:most-popular={isMostPopular}
  class:has-current-plan={showCurrentPlanOnGroupLevel || showUpcomingPlanOnGroupLevel}
  class:has-current-plan-cancelled={showCurrentPlanOnGroupLevel && !currentSubscription.active}
>
  {wrapperTitle()}
</div>
